export default "__VITE_ASSET__DJRNM6sb__"